import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { pushModalSelector } from '@/stores/modalStore';
import { Badge, badgeTypes } from '@/ui/badge';
import AccountModal from '../AccountModal';

export function LimitsBadge({ label }: { label: string | JSX.Element }) {
  const pushModal = useSetRecoilState(pushModalSelector);

  const openAccountModal = useCallback(() => {
    pushModal({
      id: 'user:account',
      startTabId: 'limits',
      Modal: AccountModal,
      onClose: () => {},
    });
  }, [pushModal]);

  return (
    <button onClick={openAccountModal} type="button">
      <Badge
        id={badgeTypes.BadgeVariants.Large}
        label={label}
        absolutePositioned={false}
      />
    </button>
  );
}
